import React, { useState } from "react";
import { Box, Divider, Typography } from "digiwash-components";
import Header from "../components/AppHeader";
import PageContainer from "../components/PageContainer";
import useBack from "../hooks/useBack";
import useProfile from "../ducks/user/hooks/useProfile";
import { Helmet } from "react-helmet";
import RadioRow from "../components/RadioRow";
import ToggleSwitchRow from "../components/ToggleSwitchRow";
import HeaderContainer from "../containers/HeaderContainer";

function Personalization() {
  let { workspaces } = useProfile();
  let [selectWorkspace, setSelectWorkspace] = useState<string>();
  let [selectSettingItem, setSelectSettingItem] = useState([]);

  let back = useBack();
  let settingArray = [
    { title: "دریافت پیامک ویژه طرح های دیجی واش", id: 1 },
    { title: "های", id: 2 },
  ];
  return (
    <>
      <Helmet>
        <title>شخصی سازی | دیجی واش</title>
      </Helmet>
      <PageContainer
        bg="common.white"
        insideBeignScrollView={
          <HeaderContainer>
            <Header title="شخصی سازی" onBack={back} />
          </HeaderContainer>
        }
      >
        <Box px="l" pt="xxl">
          <Box px="m">
            <Typography ff="mainBold" fs="l" color="common.black">
              انتخاب گروه پیش فرض
            </Typography>
          </Box>
          <Divider size="l" />
          <Box
            style={{ borderWidth: 1, borderColor: "#EBF5FA" }}
            px="l"
            py="xxl"
            br="xm"
          >
            {workspaces.list.map((workspace, index) => {
              return (
                <>
                  <RadioRow
                    title={
                      workspace.id === "personal" ? "حساب شخصی" : workspace.name
                    }
                    onSelect={() => {
                      setSelectWorkspace(workspace.id);
                    }}
                    selected={selectWorkspace === workspace.id}
                    icon={
                      workspace.id === "personal" ? "personal" : workspace.logo
                    }
                  />
                  {workspaces.list.length - 1 === index ? null : (
                    <Divider size="xxxl" />
                  )}
                </>
              );
            })}
          </Box>
          <Divider size="xxl" />
          <Box px="m">
            <Typography ff="mainBold" fs="l" color="common.black">
              تنظیمات
            </Typography>
          </Box>
          <Divider size="l" />
          <Box
            style={{ borderWidth: 1, borderColor: "#EBF5FA" }}
            px="l"
            py="xxl"
            br="xm"
          >
            {settingArray.map((item, index) => {
              return (
                <>
                  <ToggleSwitchRow
                    title={item.title}
                    onSelect={() => {
                      if (selectSettingItem.includes(item.id)) {
                        let newSelectSettingItem = selectSettingItem.filter(
                          (newItem) => {
                            if (item.id === newItem) {
                              return false;
                            } else {
                              return true;
                            }
                          }
                        );
                        setSelectSettingItem(newSelectSettingItem);
                      } else {
                        setSelectSettingItem([...selectSettingItem, item.id]);
                      }
                    }}
                    selected={selectSettingItem.includes(item.id)}
                  />
                  {settingArray.length - 1 === index ? null : (
                    <Divider size="xxxl" />
                  )}
                </>
              );
            })}
          </Box>
        </Box>
      </PageContainer>
    </>
  );
}

export default Personalization;
